var map = {
	"./Others/cutie_trick.png": 5123,
	"./Worlds/CodeSurvival.jpg": 4130,
	"./Worlds/CodeSurvival/HP_CodeSurvival_arms1.png": 7323,
	"./Worlds/CodeSurvival/HP_CodeSurvival_arms2.png": 9536,
	"./Worlds/museum.png": 7184,
	"./Worlds/prologram.png": 1665,
	"./Worlds/prologram/HP_Prologram_1.png": 7593,
	"./Worlds/prologram/HP_Prologram_2.png": 4780,
	"./default.svg": 5759
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5018;